// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__WX8dl","triangle":"Tooltip_triangle__sMK7n"};